// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Services_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/services/lista.
 *
 * Returns the list of active services for the service-orders module.
 */
import type { Services_ListaRow } from './Services_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Services_ListaResponseDados = Services_ListaRow[];

export type Services_ListaResponse = ApiResponse<Services_ListaResponseDados>;

registerResponseContract('Services_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_service_id:            { type: 'number',  required: true },
      so_service_category_id:   { type: 'number',  required: true },
      so_service_name:          { type: 'string',  required: true },
      so_service_description:   { type: 'string',  required: false },
      so_service_color:         { type: 'string',  required: false },
      so_service_default_price: { type: 'number',  required: true },
      so_service_franchise_id:  { type: 'number',  required: true },
      so_service_active:        { type: 'number',  required: true },
      so_service_created_at:    { type: 'string',  required: false },
      so_service_category_name: { type: 'string',  required: false },
      category_name:            { type: 'string',  required: false },
    },
  },
})
